import type { XY, XYZ } from "@designboticteam/core";

/**
 * Drop y-axis (y-UP)
 */
function toPlanar([x, _y, z]: XYZ): XY {
	return [x, z];
}

export { toPlanar };
